import FootballState from "../../../../../sports/football/state/football-state";
import { FragmentSerializer } from "./FragmentSerializer";
import PassBrokenUp from "../../../../../sports/football/fragments/pass-broken-up";

const toDefenderList = (brokenUpBy) => {
    if (!brokenUpBy) {
        return [];
    }
    const list = Array.isArray(brokenUpBy) ? brokenUpBy : [brokenUpBy];

    return list.filter((p) => p?.id);
};

export class PassIncompleteBrokenUpFragmentSerializer extends FragmentSerializer {
    applicable(fragment) {
        return (
            fragment.associatedState === FootballState.PassIncomplete &&
            toDefenderList(fragment.brokenUpBy).length
        );
    }

    getRawFragment(play, serializationContext, fragment) {
        const uniforms = toDefenderList(fragment.brokenUpBy).map((p) =>
            this.resolveUniform(serializationContext, p)
        );

        return `${PassBrokenUp.getCode()}:${uniforms.join()}`;
    }
}
